import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Star, MapPin, Coffee, Wifi, Award, Palmtree, Waves } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { SuperhostBadge } from '../components/SuperhostBadge';
import { TestimonialCarousel } from '../components/TestimonialCarousel';
import { PropertyCard } from '../components/PropertyCard';
import { BookingModal } from '../components/BookingModal';
export function Home() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  return <div className="flex flex-col min-h-screen" data-id="element-239">
      {/* Hero Section - Tropical Green & Gold Gradient */}
      <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-gradient-to-br from-emerald-900 via-emerald-800 to-teal-900" data-id="element-240">
        {/* Tropical Decorative Elements */}
        <div className="absolute inset-0 opacity-20" data-id="element-241">
          <div className="absolute top-20 left-10 w-96 h-96 bg-amber-400 rounded-full blur-3xl animate-pulse" data-id="element-242"></div>
          <div className="absolute bottom-20 right-10 w-[500px] h-[500px] bg-emerald-400 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-243"></div>
          <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-lime-300 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '2s'
        }} data-id="element-244"></div>
        </div>

        {/* Tropical Pattern Overlay */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C15 6.716 21.716 0 30 0zm0 45c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15z' fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
        backgroundSize: '60px 60px'
      }} data-id="element-245"></div>

        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto" data-id="element-246">
          {/* Tropical Icon */}
          <div className="flex justify-center mb-6 animate-in fade-in slide-in-from-top duration-700" data-id="element-247">
            <div className="relative" data-id="element-248">
              <Palmtree className="h-16 w-16 text-amber-300" data-id="element-249" />
              <div className="absolute -bottom-2 -right-2" data-id="element-250">
                <Waves className="h-8 w-8 text-teal-300" data-id="element-251" />
              </div>
            </div>
          </div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight animate-in fade-in slide-in-from-bottom duration-700" data-id="element-252">
            Tropical Luxury in the
            <br data-id="element-253" />
            <span className="italic font-light text-amber-300" data-id="element-254">
              Heart of Kochi
            </span>
          </h1>
          <p className="text-lg md:text-xl text-emerald-50 mb-12 max-w-3xl mx-auto font-light leading-relaxed animate-in fade-in slide-in-from-bottom duration-700 delay-150" data-id="element-255">
            Experience Kerala's heritage city through our collection of luxury
            tropical homes in Maradu.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-in fade-in slide-in-from-bottom duration-700 delay-300" data-id="element-256">
            <Link to="/collections" data-id="element-257">
              <Button size="lg" className="w-full sm:w-auto bg-gradient-to-r from-amber-400 to-amber-500 text-emerald-900 hover:from-amber-500 hover:to-amber-600 border-none shadow-2xl text-lg px-8 py-6 font-bold" data-id="element-258">
                Discover Our Homes
              </Button>
            </Link>
          </div>

          {/* Stats Bar - Tropical Theme */}
          <div className="mt-16 grid grid-cols-3 gap-8 max-w-2xl mx-auto animate-in fade-in slide-in-from-bottom duration-700 delay-500" data-id="element-259">
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-amber-300/20" data-id="element-260">
              <div className="text-4xl font-bold text-amber-300 mb-1" data-id="element-261">
                4.96+
              </div>
              <div className="text-sm text-emerald-100" data-id="element-262">Average Rating</div>
            </div>
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-amber-300/20" data-id="element-263">
              <div className="text-4xl font-bold text-amber-300 mb-1" data-id="element-264">100+</div>
              <div className="text-sm text-emerald-100" data-id="element-265">Happy Guests</div>
            </div>
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-amber-300/20" data-id="element-266">
              <div className="text-4xl font-bold text-amber-300 mb-1" data-id="element-267">4</div>
              <div className="text-sm text-emerald-100" data-id="element-268">Luxury Homes</div>
            </div>
          </div>
        </div>

        {/* Tropical Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce" data-id="element-269">
          <div className="w-6 h-10 border-2 border-amber-300/70 rounded-full flex justify-center p-1" data-id="element-270">
            <div className="w-1 h-2 bg-amber-300 rounded-full" data-id="element-271"></div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-16 bg-gradient-to-b from-white to-emerald-50" data-id="element-272">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273">
          <SuperhostBadge data-id="element-274" />
        </div>
      </section>

      {/* Featured Collection Preview */}
      <section className="py-20 bg-gradient-to-br from-emerald-50 via-lime-50 to-teal-50" data-id="element-275">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-276">
          <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-277">
            <div data-id="element-278">
              <div className="flex items-center gap-2 mb-4" data-id="element-279">
                <Palmtree className="h-8 w-8 text-emerald-600" data-id="element-280" />
                <h2 className="font-serif text-3xl md:text-4xl font-bold text-emerald-900 mb-0" data-id="element-281">
                  Our Tropical Collection
                </h2>
              </div>
              <p className="text-emerald-700 max-w-xl" data-id="element-282">
                Four distinct properties in Maradu, each a Superhost favorite.
                Book directly on Airbnb.
              </p>
            </div>
            <Link to="/collections" className="hidden md:flex items-center text-amber-600 font-medium hover:text-amber-700 transition-colors mt-4 md:mt-0" data-id="element-283">
              View All Properties <ArrowRight className="ml-2 h-4 w-4" data-id="element-284" />
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-285">
            <PropertyCard id="the-ark" title="The Ark" type="4BHK Villa" bedrooms={4} bathrooms={5} sleeps={14} beds={5} price="₹12,499" image="https://a0.muscache.com/im/pictures/hosting/Hosting-1318026329502115922/original/520ca652-f1a5-4e24-a765-74ae5cc897f8.png?im_w=1440" airbnbUrl="https://airbnb.co.in/h/fortkochin" featured={true} data-id="element-286" />
            <PropertyCard id="the-haven" title="The Haven" type="3BHK Apartment" bedrooms={3} bathrooms={5} sleeps={11} beds={5} price="₹8,499" image="https://a0.muscache.com/im/pictures/hosting/Hosting-1392648310736278217/original/50bf55c8-d9cc-4562-bc5f-0efaf4402535.jpeg?im_w=1440" airbnbUrl="https://www.airbnb.co.in/h/keralam" data-id="element-287" />
            <PropertyCard id="ark-green" title="Ark Green" type="2BHK Suite" bedrooms={2} bathrooms={2} sleeps={5} beds={2} price="₹7,499" image="https://a0.muscache.com/im/pictures/hosting/Hosting-1300574331154492461/original/f39bc531-627c-420a-b66d-74c2bb383fd3.jpeg?im_w=1440" airbnbUrl="https://www.airbnb.co.in/rooms/1312900432950527324" data-id="element-288" />
            <PropertyCard id="ark-gold" title="Ark Gold" type="2BHK Suite" bedrooms={2} bathrooms={3} sleeps={6} beds={3} price="₹6,499" image="https://a0.muscache.com/im/pictures/hosting/Hosting-1312900432950527324/original/7241b004-b870-4614-987e-63f0ae367f2d.jpeg?im_w=1440" airbnbUrl="https://www.airbnb.co.in/rooms/1300574331154492461" data-id="element-289" />
          </div>

          <div className="mt-8 text-center md:hidden" data-id="element-290">
            <Link to="/collections" data-id="element-291">
              <Button variant="outline" className="w-full border-emerald-600 text-emerald-700 hover:bg-emerald-50" data-id="element-292">
                View All Properties
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="py-24 bg-white overflow-hidden" data-id="element-293">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-295">
            <div className="relative bg-gradient-to-br from-emerald-700 via-emerald-600 to-teal-700 rounded-3xl p-12 text-white shadow-2xl overflow-hidden" data-id="element-296">
              {/* Tropical Pattern */}
              <div className="absolute inset-0 opacity-10" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20 0l20 20-20 20L0 20z' fill='%23ffffff' fill-opacity='1'/%3E%3C/svg%3E")`,
              backgroundSize: '40px 40px'
            }} data-id="element-297"></div>
              <div className="absolute -top-10 -left-10 w-40 h-40 bg-amber-400 rounded-full opacity-20 blur-2xl" data-id="element-298"></div>
              <div className="absolute -bottom-10 -right-10 w-48 h-48 bg-lime-300 rounded-full opacity-20 blur-2xl" data-id="element-299"></div>
              <div className="relative" data-id="element-300">
                <MapPin className="h-12 w-12 text-amber-300 mb-6" data-id="element-301" />
                <h3 className="font-serif text-3xl font-bold mb-4" data-id="element-302">
                  Maradu, Kochi
                </h3>
                <p className="text-emerald-50 text-lg leading-relaxed" data-id="element-303">
                  Located just minutes from Fort Kochi's Chinese Fishing Nets,
                  Marine Drive promenade, and Forum Mall. Perfect location for
                  exploring Kerala's tropical heritage city.
                </p>
              </div>
            </div>

            <div data-id="element-304">
              <span className="text-amber-600 font-bold tracking-widest uppercase text-sm mb-2 block flex items-center gap-2" data-id="element-305">
                <Palmtree className="h-4 w-4" data-id="element-306" />
                The Tropical Experience
              </span>
              <h2 className="font-serif text-4xl font-bold text-emerald-900 mb-6" data-id="element-307">
                More Than Just a Stay
              </h2>
              <p className="text-emerald-700 text-lg mb-8 leading-relaxed" data-id="element-308">
                We're locals who love Kochi. Each property comes with our
                Explorer's Handbook—a curated guide to the city's best cafes,
                heritage walks, and hidden tropical gems. Experience Kerala like
                you live here.
              </p>

              <div className="grid grid-cols-2 gap-6 mb-8" data-id="element-309">
                <div className="flex items-start gap-3 bg-gradient-to-br from-emerald-50 to-lime-50 p-4 rounded-xl border border-emerald-200" data-id="element-310">
                  <div className="bg-amber-100 p-2 rounded-lg" data-id="element-311">
                    <Coffee className="h-6 w-6 text-amber-600" data-id="element-312" />
                  </div>
                  <div data-id="element-313">
                    <h4 className="font-bold text-emerald-900" data-id="element-314">
                      Local Cafe Guide
                    </h4>
                    <p className="text-sm text-emerald-600" data-id="element-315">
                      Curated tropical brews
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-gradient-to-br from-emerald-50 to-lime-50 p-4 rounded-xl border border-emerald-200" data-id="element-316">
                  <div className="bg-amber-100 p-2 rounded-lg" data-id="element-317">
                    <Wifi className="h-6 w-6 text-amber-600" data-id="element-318" />
                  </div>
                  <div data-id="element-319">
                    <h4 className="font-bold text-emerald-900" data-id="element-320">
                      High-Speed Wifi
                    </h4>
                    <p className="text-sm text-emerald-600" data-id="element-321">
                      Work from paradise
                    </p>
                  </div>
                </div>
              </div>

              <Link to="/kochi-guide" data-id="element-322">
                <Button className="bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white border-none" data-id="element-323">
                  Explore Our Guide
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-gradient-to-br from-lime-50 via-emerald-50 to-teal-50 py-20" data-id="element-324">
        <TestimonialCarousel data-id="element-325" />
      </section>

      <BookingModal isOpen={isBookingModalOpen} onClose={() => setIsBookingModalOpen(false)} data-id="element-326" />
    </div>;
}